export const CHANGE_LANGUAGE = 'uwave/locales/CHANGE_LANGUAGE';
export const LOAD_LANGUAGE_START = 'uwave/locales/LOAD_LANGUAGE_START';
export const LOAD_LANGUAGE_COMPLETE = 'uwave/locales/LOAD_LANGUAGE_COMPLETE';
